import { Alert, AlertIcon, AlertTitle } from '@/ui';
import { isGQLErrorOfType, type QueryError } from '@/utils/errors';
import { getAuthErrorMessage } from './auth/utils';

type Props = {
  authError: QueryError;
};

export const AuthError = ({ authError }: Props): JSX.Element => {
  const isWarning = isGQLErrorOfType(
    authError,
    'MerValidationErrFailedValidation'
  );
  const serverErrorMsg = getAuthErrorMessage(authError);

  return (
    <Alert status={isWarning ? 'warning' : 'error'}>
      <AlertIcon />
      <AlertTitle>{serverErrorMsg}</AlertTitle>
    </Alert>
  );
};
